export const update = {
  updateSuccessfully: 'Update washing method successfully!',
}
